var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"col-sm-3\" style=\"padding: 2px; margin: 0;\">\n                <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" width=\"24px\" height=\"24px\"/>\n                "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"total") : depth0), depth0))
    + "\n            </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"col-xs-6\">\n                <div class=\"leaflet-popup-evaluation-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.TotalBrands",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":60},"end":{"line":14,"column":89}}}))
    + "</div>\n                <div class=\"leaflet-popup-evaluation-value\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"totalBrands") : depth0), depth0))
    + "</div>\n            </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"col-xs-6\">\n                <div class=\"leaflet-popup-evaluation-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.TotalStores",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":60},"end":{"line":20,"column":89}}}))
    + "</div>\n                <div class=\"leaflet-popup-evaluation-value\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"totalStores") : depth0), depth0))
    + "</div>\n            </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n    <div class=\"leaflet-popup-header\">"
    + container.escapeExpression(__default(require("./i18n.js")).call(alias1,"Common.Brands",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":38},"end":{"line":2,"column":62}}}))
    + "</div>\n    <div class=\"row\" style=\"padding: 0 6px 2px;\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"brands") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":8},"end":{"line":9,"column":17}}})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"leaflet-popup-evaluation\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"totalBrands") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":17,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"totalStores") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":23,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-origin-destiny-popup.hbs
// module id = hsSN
// module chunks = 1